/**
 * @generated SignedSource<<1c3e107ed1006c39786c55809a0705e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetMinimumCommitment_package$data = {
  readonly billingOptions: ReadonlyArray<{
    readonly minimumCommitmentMonths: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly id: string | null | undefined;
  readonly " $fragmentType": "useGetMinimumCommitment_package";
};
export type useGetMinimumCommitment_package$key = {
  readonly " $data"?: useGetMinimumCommitment_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetMinimumCommitment_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetMinimumCommitment_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingOption",
      "kind": "LinkedField",
      "name": "billingOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumCommitmentMonths",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "a2a36c663a398642a67d61971c8d817d";

export default node;
